import styledNormalize from 'styled-normalize';
import { createGlobalStyle, css } from 'styled-components';
import { isIFrame } from '~/utils';

export default createGlobalStyle`
  ${styledNormalize}

  * {
    box-sizing: border-box;
  }

  ${
    isIFrame() &&
    css`
      body,
      html {
        overflow: hidden;
      }
    `
  }

  html {
    height: 100%;
  }

  body {
    padding: 0;
    margin: 0;
    position: relative;
    height: 100%;
    width: 100%;
    line-height: 1.4;
    font-family: ${(p) => p.theme.fonts.sans};
    color: ${(p) => p.theme.colors.text};
  }
  .react-draggable-transparent-selection {
    .mover {
      background: ${(p) => p.theme.colors.interaction};
    }
    .tooltip {
      display: none;
    }
    cursor: grab;
  }
`;
